import React, { useContext, useEffect, useState } from 'react'
import * as ls from 'local-storage'
import Pagination from '@mui/material/Pagination'
import Alert from '@mui/material/Alert'
import { GlobalStateContext } from '../providers/GlobalStateProvider'
import { API } from '../providers/API'
import { Machine } from '../components/Machine/Machine'
import { MachineData } from '../components/Machine/Machine.types'
import { MachineFilters } from '../components/MachineFilters/MachineFilters'
import { ApprovalBox } from '../components/ApprovalBox/ApprovalBox'
import { Loading } from '../components/Loading/Loading'
import { FixedFooterContainer } from '../App.styles'

export const Service = () => {
  const [machines, setMachines] = useState([])
  const [paginatedMachines, setPaginatedMachines] = useState([])
  const [page, setPage] = useState(1)
  const [selectedBranch, setSelectedBranch] = useState<number | null>(null)
  const {
    userInfo, setPageTitle, isLoading, setIsLoading, userAccess,
  } = useContext(GlobalStateContext)
  const itemsPerPage = 20

  setPageTitle('Сервиз')

  useEffect(() => {
    setIsLoading(true)
    // TODO: no endpoint for all machines in service
    // const dataURL =
    // userInfo.bankId === null ? '/listAllService' : `/serviceList/${userInfo.bankId}`
    API.get(`/serviceList/${userInfo.bankId}`, { headers: { Authorization: `Bearer ${ls.get('loginCredentials')}` } }).then((response) => {
      setMachines(response.data)
      setIsLoading(false)
    })
  }, [])

  useEffect(() => {
    if (page === 1) {
      setPaginatedMachines(machines.filter((item: any, index: number) => index + 1 <= itemsPerPage))
    } else {
      setPaginatedMachines(machines.filter(
        // eslint-disable-next-line max-len
        (item: any, index: number) => (index + 1 > page * itemsPerPage && index + 1 <= (page + 1) * itemsPerPage),
      ))
    }
  }, [machines, page])

  return (
    <FixedFooterContainer>
      {userAccess <= 2 && (
        <MachineFilters
          setMachinesFunction={setMachines}
          setSelectedBranchFn={setSelectedBranch}
          selectedBranch={selectedBranch}
          filteredMachines={machines}
          service
        />
      )}
      {isLoading === true ? (
        <Loading />
      ) : (
        <>
          {paginatedMachines.length > 0 ? (
            paginatedMachines.map((item: MachineData) => (
              <Machine key={item.id} data={item} service />
            ))
          ) : (
            <Alert severity="info">Няма намерени машини</Alert>
          )}
          {machines.length > itemsPerPage && (
            <Pagination
              siblingCount={1}
              count={Math.floor(machines.length / itemsPerPage)}
              color="primary"
              onChange={(event, value) => setPage(value)}
            />
          )}
        </>
      )}
      <ApprovalBox service />
    </FixedFooterContainer>
  )
}
